import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { allowMoreResults, increaseNumberOfResults } from '../common/localStorage';
import analytics from '../../services/analytics';
import { handleScroll } from '../common/scroll';
import { getCompletions } from '../common/completions';
import { getCategoryName } from '../common/category';
import useStore from '../../services/store';
import displaySubmitError from '../common/submitError';

function useSubmit(selectedCategory: number) {
  const { t } = useTranslation();
  const showGenericError = useStore((state) => state.showGenericError);
  const setResultsAreGenerating = useStore((state) => state.setResultsAreGenerating);
  const addResults = useStore((state) => state.addResults);

  const handleSubmit = useCallback(
    async (values, setSubmitting) => {
      if (!allowMoreResults()) {
        showGenericError(t('editor.resultsExceededAlert'));
        return;
      }

      try {
        setResultsAreGenerating(true);

        const { actualResults, textGenerated, bodyParams, tokenInformation } = await getCompletions(
          {
            values,
            selectedCategory,
            generateMore: false,
          },
        );

        analytics.generate({
          page_path: window.location.pathname,
          text_information: bodyParams,
          category_name: getCategoryName(selectedCategory),
        });
        analytics.textGenerated({
          page_path: window.location.pathname,
          text_information: textGenerated,
          category_name: getCategoryName(selectedCategory),
          token_information: tokenInformation,
        });
        addResults({
          category: selectedCategory,
          newResults: actualResults,
          replace: true,
        });
        handleScroll('qt_copywriter_results');
        setSubmitting(false);
        increaseNumberOfResults();
      } catch (err) {
        displaySubmitError({ type: 'submit', err, showGenericError });
      }
      setResultsAreGenerating(false);
    },
    [selectedCategory, showGenericError],
  );

  return handleSubmit;
}

export default useSubmit;
